import { render, staticRenderFns } from "./FooterSection.vue?vue&type=template&id=1b4192d6&scoped=true&"
import script from "./FooterSection.vue?vue&type=script&lang=ts&"
export * from "./FooterSection.vue?vue&type=script&lang=ts&"
import style0 from "./FooterSection.vue?vue&type=style&index=0&id=1b4192d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4192d6",
  null
  
)

export default component.exports